import { FC } from 'react'
import BaseSuccess from './BaseSuccess'

const ShowingChoiceSuccess: FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <BaseSuccess
      onClose={onClose}
      header="Showing Choice Preferences Updated"
      message="Your new listings will no longer include a showing management service. All previous listings that used SentriKey Showing Service will no longer retain them as their existing showing management service. However, any previously published active listings that used ShowingTime will continue to retain them as their existing showing management service."
    />
  )
}

export default ShowingChoiceSuccess
